import { useMemo } from 'react';

import { getSmartCardOptions } from '../utils/smartCardOptions';

export const useSmartCards = (isChromelessEditor: boolean = false) => {
	return useMemo(() => {
		return getSmartCardOptions(isChromelessEditor);
	}, [isChromelessEditor]);
};
